module.exports = __webpack_public_path__ + "static/media/Never Looking Back - Instrumental Version.4b958102.jpg";